import z from 'zod';

export const tradeListRecentRequestSchema = z.object({
  /** Most recently opened trades (by `openedAt` desc). Default 3. */
  recentLimit: z.number().int().min(1).max(50).optional().default(3),
  /** Open trades only (`status === open`), by `openedAt` desc. Default 3. */
  openLimit: z.number().int().min(1).max(50).optional().default(3),
});

export interface TradeListRecentRequestParsed extends z.infer<typeof tradeListRecentRequestSchema> {}
